import { render, staticRenderFns } from "./talk.vue?vue&type=template&id=42a910dd&lang=pug"
import script from "./talk.vue?vue&type=script&lang=js"
export * from "./talk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports